import { Component, inject } from '@angular/core';
import { LfwRouterService } from '../../route/lfw-router.service';
import { MessageService } from '../message.service';
import { AsyncPipe } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatBadge } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lfw-messages-button',
  templateUrl: './messages-button.component.html',
  styleUrls: ['./messages-button.component.css'],
  imports: [MatIconButton, MatBadge, MatIcon, AsyncPipe]
})
export class MessagesButtonComponent {
  private routerService = inject(LfwRouterService);
  private messagesService = inject(MessageService);
  messageCount$ = this.messagesService.observe();

  btnClick() {
    this.routerService.navigateToMessages();
  }
}
